import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-sol bg-navy text-white" data-id="element-92" data-mp="9lbg511q9bdl">
      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-93" data-mp="4mi3fau9loeh">
        <p className="inline-block rounded-md bg-sol px-2 py-0.5 font-sub text-xs font-bold uppercase leading-tight text-navy sm:text-sm" data-id="element-94" data-mp="1297c23jh2z9b">
          Método de aprendizaje paso a paso
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="mt-2 font-display text-[1.5rem] font-extrabold uppercase leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-95" data-mp="sbb5lp1hcshj">
          El sistema completo para aprender{' '}
          <span className="text-sol" data-id="element-96" data-mp="381nvnbrr4x50">Inglés para viajar</span>{' '}
          <span className="bg-sol px-1.5 text-navy" data-id="element-97" data-mp="3j7zgfm2d3yi9">desde cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/90" data-id="element-98" data-mp="3o7c243hhyzj9">
          Aprendé el inglés que realmente necesitás para viajar, comunicarte en
          aeropuertos, pasar migraciones, reservar hoteles, pedir comida y
          resolver situaciones cotidianas —{' '}
          <strong className="font-bold text-sol" data-id="element-99" data-mp="35a2hij0frg0f">
            sin perder meses estudiando gramática complicada ni memorizar
            palabras que nunca vas a utilizar.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg border-2 border-sol bg-navy-light px-3 py-1.5 font-sub text-xs font-bold uppercase leading-tight text-white sm:text-sm" data-id="element-100" data-mp="2vgu25bc2lea2">
          {PRODUCT_NAME} · <span className="text-sol" data-id="element-101" data-mp="2ljz5yz39rpyy">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-sol bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sol" data-id="element-102" data-mp="s2tf1pz30hru">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-103" data-mp="1b0ds7zshhrwm" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-semibold leading-snug text-white/90 sm:text-sm" data-id="element-104" data-mp="111etb8xitamt">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos.
        </p>

        <div className="mt-2.5" data-id="element-105" data-mp="3lt76qudfzxvu">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-106" data-mp="3lui86njf0tjs">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-white/85" data-id="element-107" data-mp="3htg8y6pi0hht">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}